/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { SecondaryDeviceCardProps } from './types';
import './styles.scss';
import TSecondaryDeviceCard, {
  SecondaryDeviceCardAnalytics
} from './SecondaryDeviceCard';

/**
 * UI Toolkit : secondary device card
 * @public
 */

const SecondaryDeviceCard: React.FC<SecondaryDeviceCardProps> = ({
  deviceNickname,
  deviceModelName,
  deviceImage,
  onCardClick,
  statusList,
  children,
  trackId,
  loading = false,
  ...rest
}) => {
  if (trackId) {
    return (
      <SecondaryDeviceCardAnalytics
        {...{
          deviceNickname,
          deviceModelName,
          deviceImage,
          onCardClick,
          statusList,
          children,
          loading,
          trackId,
          ...rest
        }}
      />
    );
  }
  return (
    <TSecondaryDeviceCard
      {...{
        deviceNickname,
        deviceModelName,
        deviceImage,
        onCardClick,
        statusList,
        loading,
        children
      }}
    />
  );
};

export default SecondaryDeviceCard;
